import React, { useState } from "react";
import styles from "../../assets/styles/ImageSlider.module.scss";

const ImageSlider2 = ({ slides }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const sliderStyles = {
    width: "100%",
    height: "100%",
    position: "relative",
  };

  const slideStyles = {
    width: "100%",
    height: "100%",
  };

  const imageStyles = {
    width: "100%",
    height: "100%",
  };

  const leftArrowStyle = {
    position: "absolute",
    top: "50%",
    transform: "translate(0, -50%)",
    right: "300px",
    fontSize: "4.5rem",
    color: "#4A4A68",
    zIndex: 2,
    cursor: "pointer",
  };

  const rightArrowStyle = {
    position: "absolute",
    top: "50%",
    transform: "translate(0, -50%)",
    left: "300px",
    fontSize: "4.5rem",
    color: "#4A4A68",
    zIndex: 2,
    cursor: "pointer",
  };

  const dotsContainerStyles = {
    display: "flex",
    justifyContent: "center",
  };

  const dotStyles = {
    margin: "0 3px",
    fontSize: "400px",
    cursor: "pointer",
  };

  const goToPrevious = () => {
    const isFirstSlide = currentIndex === 0;
    const newIndex = isFirstSlide ? slides.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);
  };

  const goToNext = () => {
    const isLastSlide = currentIndex === slides.length - 1;
    const newIndex = isLastSlide ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
  };

  const goToSlide = (slideIndex) => {
    setCurrentIndex(slideIndex);
  };

  return (
    <div style={sliderStyles} className={styles.slide}>
      <div className={styles.leftarr} onClick={goToPrevious}>
        {" "}
        ❰{" "}
      </div>
      <div className={styles.rightarr} onClick={goToNext}>
        {" "}
        ❱{" "}
      </div>
      <div style={slideStyles}>
        <img
          src={slides[currentIndex].img}
          alt={slides[currentIndex].title}
          className={styles.slide__img}
        />
      </div>
      <div style={dotsContainerStyles}>
        {slides.map((slide, slideIndex) => (
          <div
            key={slideIndex}
            style={dotStyles}
            onClick={() => goToSlide(slideIndex)}
          >
            •
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImageSlider2;
